module.exports = __webpack_public_path__ + "static/media/banner-0.8c753694.jpg";